export const LOCAL_KEY_USER_NAME = 'LOCAL_KEY_USER_NAME' // localStorage中的user的key值
export const LOCAL_KEY_USER_CODE = 'LOCAL_KEY_USER_CODE' // localStorage中的userCode的key值
export const LOCAL_KEY_PART_NO = 'LOCAL_KEY_PART_NO' // localStorage中的partNo的key值
export const LOCAL_KEY_CSH_PIKER = 'LOCAL_KEY_CSH_PIKER' // localStorage中的cshNo的key值
export const LOCAL_KEY_ORDER_STATUS = 'LOCAL_KEY_ORDER_STATUS' // localStorage中的订单状态的key值
export const LOCAL_KEY_ORDER_STATUS_INDEX = 'LOCAL_KEY_ORDER_STATUS_INDEX' // localStorage中的订单状态的key值
export const LOCAL_KEY_USERTYPE = 'LOCAL_KEY_USERTYPE' // localStorage中的用户类型的key值
export const LOCAL_KEY_USERTYPE_INDEX = 'LOCAL_KEY_USERTYPE_INDEX' // localStorage中的用户类型的key值
export const LOCAL_KEY_SHOW_PERSONAL = 'LOCAL_KEY_SHOW_PERSONAL' // localStorage中的显示个人用户类型的key值showPersonal
export const LOCAL_KEY_SEARCH_CONTENT = 'LOCAL_KEY_SEARCH_CONTENT' // localStorage中的库存查询的搜索内容


export const STATUS_CODE_OK = '100001'
export const MOBILE_URL = process.env.VUE_APP_MOBILE_URL;